module.exports = __webpack_public_path__ + "static/media/Mascote-chat.7ad845d7.svg";